import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Grid,
  Icon,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  AutoCompleteWithTopLabel,
  DateSelectorWithTopLabelComponent,
  TextFieldWithTopLabelComponent,
} from '../../uiComponent/fhirComponentUi';
import React, { useEffect, useState, Fragment, useCallback } from 'react';
import { v1 as uuidv1 } from 'uuid';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';
import { ROLE_PROVIDER } from '../../../../pages/auth/constants';
import {
  CREATE_DYNAMIC_FORM,
  ehrAPIBaseService,
  ehrAPIServiceMeta,
} from '../../../../http-common';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { setProgress } from '../../../../redux/features/progressSlice';
import {
  useMainFrameDispatch,
  useMainFrameState,
} from '../../../MainUIFrame/MainFrame';
import {
  ACTION_CLOSE_RIGHT_FLOATING_DRAWER,
  ACTION_OPEN_RIGHT_FLOATING_DRAWER,
} from '../../../MainUIFrame/constants';
import { ExpandMore, Height } from '@mui/icons-material';
import styled from '@emotion/styled';
import { red } from '@mui/material/colors';

const TASK_OPTIONS_LIST = [
  { code: 'intakeForm', display: 'Intake Form' },
  { code: 'questionaireForm', display: 'Rating Scale Form' },
  { code: 'fillGenericForm', display: 'Fill Form' },
  { code: 'uploadDocuments', display: 'Upload Documents' },
  { code: 'other', display: 'Other' },
];

const TASK_QUESTIONAIRE_FORM_OPTION_LIST = [
  { display: 'Beck Anxiety Inventory', code: 'bai' },
  { display: 'Beck Depression Inventory', code: 'bdi' },
  { display: 'PHQ-9', code: 'phq-9' },
  { display: 'QIDS', code: 'qids' },
  { display: 'AIMS', code: 'aims' },
  { display: 'WHODAS', code: 'whodas' },
  { display: 'GAD-7', code: 'gad-7' },
  { display: 'Fagerstrom Test for Cigarette Dependence', code: 'ftcd' },
  { display: 'Columbia Suicide Severity Rating Scale', code: 'cssrs' },
  { display: 'LEC-5', code: 'lec-5' },
  { display: 'PCL-5', code: 'pcl-5' },
  { display: 'TASR-AM', code: 'tasr-am' },
  { display: 'CAGE', code: 'cage' },
  { display: 'CAGE-AID', code: 'cage-aid' },
];

const TASK_DOCUMENT_UPLOAD_OPTIONS_LIST = [
  { code: 'governmentId', display: 'Government Id' },
  { code: 'drivingLicense', display: 'Driving License' },
  { code: 'other', display: 'Other' },
];

const ASK_TO_UPLOAD_OPTIONS_LIST = [
  {
    code: false,
    display: 'No',
  },
  { code: true, display: 'Yes' },
];

const initialTaskObject = {
  id: uuidv1(),
  taskTypeObject: {
    label: 'Task Type',
    // value: TASK_OPTIONS_LIST?.[0],
    value: null,
    optionsList: TASK_OPTIONS_LIST,
  },
  subTaskObject: {
    label: 'Type',
    // value: TASK_QUESTIONAIRE_FORM_OPTION_LIST?.[0],
    value: null,
    // optionsList: TASK_QUESTIONAIRE_FORM_OPTION_LIST,
    optionsList: [],
  },
  dueDateObject: null,
  // askToUploadObject: ASK_TO_UPLOAD_OPTIONS_LIST?.[0],
  askToUploadObject: null,
  annotationNote: '',
};

const otherOptionsList = [{ code: 'other', display: 'Other' }];
const intakeForm = [{ code: 'intakeForm', display: 'Intake Form' }];
const AddTaskRightDrawer = props => {
  const [taskViewList, setTaskViewList] = useState([{ ...initialTaskObject }]);
  const [accordianViewList, setAccordianViewList] = useState([]);
  const { isRightDrawerOpen } = useMainFrameState();
  const [initialOptions, setInitialOptions] = useState([]);
  const [formsOptionsList, setFormsOptionList] = useState([]);

  dayjs.extend(utc);

  const reduxDispatch = useDispatch();
  const dispatch = useMainFrameDispatch();

  const currentReduxPatientObject = useSelector(
    state => state?.current?.currentPatientObject
  );

  const tenantPractitioner = useSelector(
    state => state?.current?.tenantPractitioner
  );

  const tenantOrganization = useSelector(
    state => state?.current?.tenantOrganization
  );

  const TASK_TO_SUBTASK_MAP = {
    questionaireForm: TASK_QUESTIONAIRE_FORM_OPTION_LIST,
    uploadDocuments: TASK_DOCUMENT_UPLOAD_OPTIONS_LIST,
    fillGenericForm: formsOptionsList,
    other: otherOptionsList,
    intakeForm: intakeForm,
  };

  // const getFormsList = async () => {
  //   const jwtPayload = jwtDecode(localStorage.getItem('jwtToken'));
  //   const tenantId = jwtPayload?.firebase?.tenant;
  //   try {
  //     reduxDispatch(setProgress(true));
  //     let params = {};
  //     params.offset = 0;
  //     params.limit = 10;
  //     const jwtPayload = jwtDecode(localStorage.getItem('jwtToken'));
  //     const tenantId = jwtPayload?.firebase?.tenant;
  //     const response = await ehrAPIServiceMeta.post(
  //       `${tenantId}/forms/form/list`,
  //       params,
  //       {
  //         headers: {
  //           'x-hasura-role': `admin`,
  //           'x-hasura-admin-secret': `c042293c-7ae1-43c5-bda1-fc3519f5fac2`,
  //         },
  //       }
  //     );

  //     let newList = response?.data?.Production_SLForm?.map(form => {
  //       return {
  //         code: form?.key,
  //         display: form?.formName,
  //         currentItem: form,
  //       };
  //     });
  //     setInitialOptions(
  //       response?.data?.Production_SLForm?.map(form => ({
  //         code: form?.key,
  //         display: form?.formName,
  //         currentItem: form,
  //       }))
  //     );

  //     console.log('form list', newList);
  //     // setFormsOptionList(newList);
  //   } catch (e) {
  //     console.error(e);
  //   } finally {
  //     reduxDispatch(setProgress(false));
  //   }
  // };

  useEffect(() => {
    // getFormsList();
  }, []);

  const [errorMessage, setErrorMessage] = useState('');

  const handleOnChange = event => {
    const { name, value } = event?.target;
    // const name = "subTaskSigleSelect"
    console.log('values', name, value);
    const { itemId, currentValue } = value;
    const propertyMap = {
      taskTypeSingleSelect: 'taskTypeObject',
      subTaskSigleSelect: 'subTaskObject',
      dueDate: 'dueDateObject',
      askToUploadDocuments: 'askToUploadObject',
      annotationNote: 'annotationNote',
    };

    if (Object.keys(propertyMap).includes(name)) {
      setTaskViewList(prevTaskViewList =>
        prevTaskViewList?.map(item => {
          if (item?.id !== itemId) {
            return item;
          }

          if (name === 'taskTypeSingleSelect') {
            if (!currentValue) {
              return {
                ...item,
                taskTypeObject: { ...item?.taskTypeObject, value: null },
                subTaskObject: {
                  ...item.subTaskObject,
                  optionsList: [],
                  value: null,
                },
              };
            }
            return {
              ...item,
              taskTypeObject: { ...item?.taskTypeObject, value: currentValue },
              subTaskObject: {
                ...item.subTaskObject,
                optionsList: TASK_TO_SUBTASK_MAP?.[currentValue?.code],
                value: TASK_TO_SUBTASK_MAP?.[currentValue?.code]?.[0],
              },
              askToUploadObject: {
                code: currentValue?.code === 'uploadDocuments' ? true : false,
                display:
                  currentValue?.code === 'uploadDocuments' ? 'Yes' : 'No',
              },
            };
          }

          if (name === 'subTaskSigleSelect') {
            return {
              ...item,
              subTaskObject: {
                ...item.subTaskObject,
                value: currentValue,
              },
            };
          }

          const propertyToUpdate = propertyMap[name];
          return {
            ...item,
            [propertyToUpdate]: currentValue,
          };
        })
      );
    }
  };

  const InfiniteLoadAutocomplete = ({
    onChange,
    value,
    name,
    disabled = false,
  }) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [searchInput, setSearchInput] = useState('');
    const limit = 1000; // You can adjust the limit as required
    const jwtPayload = jwtDecode(localStorage.getItem('jwtToken'));
    const tenantId = jwtPayload?.firebase?.tenant;
    const [open, setOpen] = useState(false);

    const fetchData = async (newSearch = false) => {
      if (loading) return;
      setLoading(true);

      const currentOffset = newSearch ? 0 : offset;

      try {
        const postData = {
          offset: currentOffset,
          limit: 1000,
        };

        /* if (searchInput) {
          postData.word = `%${searchInput}%`;
        }*/

        const response = await ehrAPIServiceMeta.post(
          `${tenantId}/forms/form/list`,
          postData,
          {
            headers: {
              'x-hasura-role': 'admin',
              'x-hasura-admin-secret': 'c042293c-7ae1-43c5-bda1-fc3519f5fac2',
            },
          }
        );

        if (response?.data?.Production_SLForm) {
          const newList = response.data.Production_SLForm.map(form => ({
            code: form?.key,
            display: form?.formName,
            currentItem: form,
          }));

          if (newSearch) {
            setOptions(newList);
            setHasMore(newList.length >= 1000);
            setOffset(newList.length);
          } else {
            setOptions(prevOptions => [...prevOptions, ...newList]);
            setOffset(prevOffset => prevOffset + newList.length);
            setHasMore(newList.length >= 1000);
          }
        } else {
          setHasMore(false);
        }
      } catch (e) {
        console.error('Error fetching data: ', e);
        setHasMore(false);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      if (open && options.length === 0) {
        // If autocomplete is open, fetch data
        fetchData();
      }
    }, [open]); // Dependency on open state

    const handleSearchInputChange = (event, newInputValue) => {
      setSearchInput(newInputValue);

      if (newInputValue === '') {
        setOptions([]); // Clear options if the search input is empty
        setHasMore(false); // Since there are no options, we can't have more
      } else {
        fetchData(true); // New search
      }
    };

    const handleAutocompleteChange = (event, newValue) => {
      onChange({
        target: {
          name: name,
          value: newValue,
        },
      });
    };

    const handleScroll = event => {
      if (loading || !hasMore) return;
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if (scrollHeight - scrollTop === clientHeight) {
        fetchData();
      }
    };

    return (
      <Grid item xs={12}>
        <Typography sx={{ fontSize: '14px' }}>
          Type <font color="red">*</font>
        </Typography>
        <Autocomplete
          size="small"
          options={hasMore ? options : [...options, { endResult: true }]}
          getOptionLabel={option =>
            option.endResult ? 'End of the items' : option.display
          }
          renderOption={(props, option) =>
            option.endResult ? (
              <li
                {...props}
                style={{ pointerEvents: 'none', color: '#387CA3' }}
              >
                End of the items
              </li>
            ) : (
              <li {...props}>{option.display}</li>
            )
          }
          value={value}
          onChange={handleAutocompleteChange}
          //onInputChange={handleSearchInputChange}
          //inputValue={searchInput}
          disabled={disabled}
          loading={loading}
          renderInput={params => (
            <TextField
              {...params}
              size="small"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          ListboxProps={{
            onScroll: handleScroll,
          }}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => {
            setOpen(false);
            setSearchInput(''); // Clear search input on close to display all options when reopened
          }}
        />
      </Grid>
    );
  };

  const handleOnClick = async event => {
    const { name, value } = event?.target;

    if (name === 'assignTask') {
      try {
        reduxDispatch(setProgress(true));

        const decodedJwt = jwtDecode(localStorage?.getItem(`jwtToken`));

        let taskOwnerObject = {};
        if (decodedJwt?.enlivRoles?.includes(ROLE_PROVIDER)) {
          taskOwnerObject = {
            reference: `${tenantPractitioner?.resourceType}/${tenantPractitioner?.id}`,
            display: `${tenantPractitioner?.name?.[0]?.text} - ${ROLE_PROVIDER}`,
          };
        } else {
          let roleList = decodedJwt?.enlivRoles?.filter(
            role => role !== ROLE_PROVIDER
          );
          taskOwnerObject = {
            reference: `${tenantOrganization?.resourceType}/${tenantOrganization?.id}`,
            display: `${tenantOrganization?.name} - ${
              roleList?.length > 0 && roleList?.[0]
            }`,
          };
        }

        const authoredOnUtc = dayjs()?.utc()?.format();

        const taskList = [];

        for (const item of accordianViewList) {
          const {
            taskTypeObject,
            subTaskObject,
            dueDateObject,
            askToUploadObject,
            annotationNote,
          } = item;

          const dueDateUtc = dayjs(dueDateObject)?.utc()?.format();
          let payload = {
            resourceType: 'Task',
            authoredOn: authoredOnUtc,
            status: 'requested',
            for: {
              reference: `Patient/${currentReduxPatientObject?.id}`,
              display: currentReduxPatientObject?.name?.fullNameText,
            },
            owner: taskOwnerObject,
            intent: 'order',
            code: {
              coding: [
                {
                  system: 'http://enliv.com/code/task-type',
                  code: taskTypeObject?.value?.code,
                  display: taskTypeObject?.value?.display,
                },
                {
                  system: 'http://enliv.com/code/sub-task-type',
                  code: subTaskObject?.value?.code,
                  display: subTaskObject?.value?.display,
                },
              ],
            },
            executionPeriod: {
              end: dueDateUtc,
            },
            input: [],
            extension: [
              {
                url: 'http://enliv.com/fhir/StructureDefinition/askToUpload',
                valueBoolean: askToUploadObject?.code,
              },
            ],
          };

          if (annotationNote) {
            payload.note = [
              {
                authorReference: taskOwnerObject,
                time: authoredOnUtc,
                text: annotationNote,
              },
            ];
          }

          if (taskTypeObject?.value?.code === 'fillGenericForm') {
            try {
              reduxDispatch(setProgress(true));

              const formId = subTaskObject?.value?.code;

              // const { formId, formDataId } = await CREATE_DYNAMIC_FORM({
              //   formKey: subTaskObject?.value?.code,
              //   userId: currentReduxPatientObject?.id,
              // });

              payload.input.push(
                {
                  type: {
                    coding: [
                      {
                        system:
                          'http://enliv.com/code/sub-task-type/generic-form/form-key',
                        code: 'formKey',
                        display: 'Form Key',
                      },
                    ],
                    text: 'Form Data Id',
                  },
                  valueString: formId,
                },
                {
                  type: {
                    coding: [
                      {
                        system:
                          'http://enliv.com/code/sub-task-type/generic-form/form-data-id',
                        code: 'formDataId',
                        display: 'Form Data Id',
                      },
                    ],
                    text: 'Form Data Id',
                  },
                  valueString: '',
                }
              );
            } catch (e) {
              console.error(e);
            } finally {
              reduxDispatch(setProgress(false));
            }
          }

          taskList.push(payload);
        }

        let fhirTaskItemList = taskList;

        const mainBundle = {
          resourceType: 'Bundle',
          type: 'batch',
          entry: fhirTaskItemList?.map(task => ({
            resource: task,
            request: {
              method: 'POST',
              url: 'Task',
            },
          })),
        };

        await ehrAPIBaseService.post(`fhir/executeBundle`, mainBundle);

        if (props?.gridRefreshCallback) {
          props?.gridRefreshCallback();
        }
        dispatch({ type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER });
      } catch (e) {
        console.error(e);
      } finally {
        reduxDispatch(setProgress(false));
      }
    }

    if (name === 'showAccordianTaskList') {
      let isAllFieldsValid = true;
      taskViewList?.forEach(item => {
        const myDate = new Date(item?.dueDateObject)?.valueOf();
        if (
          !(
            item?.dueDateObject &&
            !isNaN(myDate) &&
            !(myDate < 0) &&
            item?.taskTypeObject?.value &&
            item?.subTaskObject?.value
          )
        ) {
          isAllFieldsValid = false;
        }
      });
      if (isAllFieldsValid) {
        setErrorMessage('');
        setAccordianViewList([...accordianViewList, ...taskViewList]);
        setTaskViewList([{ ...initialTaskObject, id: uuidv1() }]);
      } else {
        setErrorMessage('Please Fill All Mandatory * Fields.');
      }
    }

    if (name === 'addTaskView') {
      let isAllFieldsValid = true;
      taskViewList?.forEach(item => {
        const myDate = new Date(item?.dueDateObject)?.valueOf();
        if (
          !(
            item?.dueDateObject &&
            !isNaN(myDate) &&
            !(myDate < 0) &&
            item?.taskTypeObject?.value &&
            item?.subTaskObject?.value
          )
        ) {
          isAllFieldsValid = false;
        }
      });
      if (isAllFieldsValid) {
        setErrorMessage('');
        let newObject = { ...initialTaskObject, id: uuidv1() };
        let newTaskViewList = [...taskViewList, newObject];
        setTaskViewList(newTaskViewList);
      } else {
        setErrorMessage('Please Fill All Mandatory * Fields.');
      }
    }

    if (name === 'deleteTaskView') {
      const { item } = value;
      let newTaskViewList = taskViewList?.filter(o => o?.id !== item?.id);
      setTaskViewList(newTaskViewList);
      let isAllFieldsValid = true;
      newTaskViewList?.forEach(item => {
        const myDate = new Date(item?.dueDateObject)?.valueOf();
        if (
          !(
            item?.dueDateObject &&
            !isNaN(myDate) &&
            !(myDate < 0) &&
            item?.taskTypeObject?.value &&
            item?.subTaskObject?.value
          )
        ) {
          isAllFieldsValid = false;
        }
      });
      if (isAllFieldsValid) {
        setErrorMessage('');
      }
    }
    if (name === 'deleteAccordionTask') {
      const { item } = value;

      let newTaskViewList = accordianViewList?.filter(o => o?.id !== item?.id);
      setAccordianViewList(newTaskViewList);
    }
    if (name === 'saveTask') {
    }
  };

  useEffect(() => {
    console.log('task', taskViewList);
  }, []);

  const repeatingUnit = (item, idx, title) => {
    const isFillFormSelected = () => {
      return item?.taskTypeObject?.value?.code === 'fillGenericForm';
    };
    console.log('fill', item?.taskTypeObject?.value?.code);
    return (
      <Fragment key={item?.id}>
        {taskViewList?.length > 1 || accordianViewList?.length ? (
          <Grid item sm={12}>
            <Grid
              alignItems={'center'}
              justifyContent={'center'}
              item
              display={'flex'}
              sm={12}
            >
              <Grid item sm={6}>
                <Typography color={`primary`}>
                  {title
                    ? `${
                        title?.length > 12 ? `${title?.slice(0, 12)}...` : title
                      }`
                    : `New Task ${idx + 1}`}
                </Typography>
              </Grid>
              <Grid display={'flex'} justifyContent={'flex-end'} item sm={6}>
                <IconButton
                  onClick={() =>
                    handleOnClick({
                      target: {
                        name: `${
                          title ? 'deleteAccordionTask' : 'deleteTaskView'
                        }`,
                        value: { item },
                      },
                    })
                  }
                >
                  <Icon color="primary">delete</Icon>
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <></>
        )}
        <Grid sm={12} sx={{ paddingLeft: title ? '' : '16px' }}>
          <AutoCompleteWithTopLabel
            {...item?.taskTypeObject}
            onChange={event =>
              handleOnChange({
                target: {
                  name: 'taskTypeSingleSelect',
                  value: {
                    itemId: item?.id,
                    currentValue: event?.target?.value,
                  },
                },
              })
            }
            validation={{
              required: true,
            }}
            disabled={title}
          />
        </Grid>
        {((title &&
          accordianViewList?.[idx]?.taskTypeObject?.value?.code !== 'other' &&
          accordianViewList?.[idx]?.taskTypeObject?.value?.code !==
            'intakeForm') ||
          (!title &&
            taskViewList?.[idx].taskTypeObject?.value?.code !== 'other' &&
            taskViewList?.[idx].taskTypeObject?.value?.code !==
              'intakeForm')) && (
          <Grid item sm={12}>
            {isFillFormSelected() && (
              <InfiniteLoadAutocomplete
                onChange={event => {
                  handleOnChange({
                    target: {
                      name: 'subTaskSigleSelect',
                      value: {
                        itemId: item?.id,
                        currentValue: event?.target?.value,
                      },
                    },
                  });
                }}
                {...item?.subTaskObject}
                disabled={title}
                validation={{
                  required: true,
                }}
              />
            )}
            {isFillFormSelected() ? null : (
              <AutoCompleteWithTopLabel
                onChange={event => {
                  handleOnChange({
                    target: {
                      name: 'subTaskSigleSelect',
                      value: {
                        itemId: item?.id,
                        currentValue: event?.target?.value,
                      },
                    },
                  });
                }}
                {...item?.subTaskObject}
                disabled={title}
                validation={{
                  required: true,
                }}
              />
            )}
          </Grid>
        )}
        <Grid item sm={12}>
          <DateSelectorWithTopLabelComponent
            onChange={event => {
              handleOnChange({
                target: {
                  name: 'dueDate',
                  value: {
                    itemId: item?.id,
                    currentValue: event?.target?.value,
                  },
                },
              });
            }}
            validation={{
              required: true,
            }}
            label="Due Date"
            value={item?.dueDateObject}
            disabled={title}
          />
        </Grid>
        <Grid item sm={12}>
          <AutoCompleteWithTopLabel
            label={`Upload Documents`}
            onChange={event =>
              handleOnChange({
                target: {
                  name: 'askToUploadDocuments',
                  value: {
                    itemId: item?.id,
                    currentValue: event?.target?.value,
                  },
                },
              })
            }
            optionsList={ASK_TO_UPLOAD_OPTIONS_LIST}
            value={item?.askToUploadObject}
            disabled={
              (item?.taskTypeObject?.value?.display === 'Upload Documents' &&
                true) ||
              title
            }
          />
        </Grid>
        <Grid item sm={12}>
          <TextFieldWithTopLabelComponent
            multiline={true}
            rows={4}
            label="Note"
            value={item?.annotationNote}
            onChange={event =>
              handleOnChange({
                target: {
                  name: 'annotationNote',
                  value: {
                    itemId: item?.id,
                    currentValue: event?.target?.value,
                  },
                },
              })
            }
            disabled={title}
          />
        </Grid>
      </Fragment>
    );
  };

  const editableTaskView = () => (
    <Fragment>
      {taskViewList?.map((item, idx) => repeatingUnit(item, idx))}
      {errorMessage && (
        <Grid item sm={12}>
          <Typography color={'error'} sx={{ fontSize: '14px' }}>
            {errorMessage}
          </Typography>
        </Grid>
      )}
      <Grid container item sm={12}>
        <Grid
          item
          sm={12}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Grid>
            <Box
              display={'flex'}
              alignItems={'center'}
              sx={{ marginLeft: '-10px' }}
            >
              <IconButton
                onClick={() =>
                  handleOnClick({
                    target: {
                      name: 'addTaskView',
                    },
                  })
                }
              >
                <Icon color="primary">add_circle</Icon>
              </IconButton>
              <Box>
                <Typography
                  onClick={() =>
                    handleOnClick({
                      target: {
                        name: 'addTaskView',
                      },
                    })
                  }
                  color="primary"
                  sx={{
                    textDecoration: 'underline',
                    '&:hover': { cursor: 'pointer' },
                  }}
                >
                  Add another task
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid>
            <Button
              name="showAccordianTaskList"
              onClick={handleOnClick}
              variant="contained"
              disabled={!taskViewList?.length}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );

  const CustomAccordion = styled(Accordion)(({ theme }) => {
    return {
      boxShadow: 'none',
      border: `1px solid #EBF2F6`,
      '.MuiAccordionDetails-root': {
        padding: '10px 5px',
        margin: '0px',
      },
      borderRadius: '5px',
      '.MuiAccordionSummary-root': {
        padding: '2px 10px',
        margin: '0px',
        minHeight: '24px',
        backgroundColor: '#EBF2F6',
        color: 'black',
      },
      '.MuiAccordionSummary-content': {
        margin: '0px',
      },
      '.MuiTypography-root': {
        fontWeight: '500',
        paddingLeft: '5px',
      },
      '.MuiAccordionSummary-expandIconWrapper': {
        color: 'black',
      },
      '.MuiAccordion-root:before': {
        height: '0px',
      },
      '&::before': {
        height: '0px',
      },
    };
  });

  const accordianTaskView = () => {
    return (
      <Fragment>
        {accordianViewList?.map((item, index) => {
          const title = `${index + 1}. ${
            item?.taskTypeObject?.value?.display
          } - ${item?.subTaskObject?.value?.display}`;
          return (
            <>
              <CustomAccordion sx={{ marginBottom: '10px' }} square>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Tooltip title={title}>
                    <Typography>
                      {title?.length > 22 ? `${title?.slice(0, 22)}...` : title}
                    </Typography>
                  </Tooltip>
                </AccordionSummary>
                <AccordionDetails>
                  {repeatingUnit(item, index, title)}
                </AccordionDetails>
              </CustomAccordion>
            </>
          );
        })}
        <hr />
      </Fragment>
    );
  };

  const actionsOnAccordianTaskView = () => {
    return (
      <Grid container item spacing={1} sm={12}>
        <Grid item sm={12}>
          <Button
            onClick={handleOnClick}
            fullWidth
            variant="contained"
            name="assignTask"
          >
            Assign
          </Button>
        </Grid>
        <Grid item sm={12}>
          <Button
            variant="outlined"
            onClick={() =>
              dispatch({ type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER })
            }
            fullWidth
            name="cancel"
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 60px)',
      }}
    >
      <Grid sx={{ flex: '1', overflow: 'auto', paddingBottom: '10px' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Grid
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
            container
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: isRightDrawerOpen ? 'flex-start' : 'center',
                alignItems: 'center',
              }}
            >
              {isRightDrawerOpen ? (
                <IconButton
                  onClick={() => {
                    dispatch({ type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER });
                  }}
                >
                  <Icon>chevron_right</Icon>
                </IconButton>
              ) : (
                <IconButton
                  onClick={() => {
                    dispatch({ type: ACTION_OPEN_RIGHT_FLOATING_DRAWER });
                  }}
                >
                  <Icon>chevron_left</Icon>
                </IconButton>
              )}
            </Box>
            {isRightDrawerOpen && (
              <Grid container spacing={1} px={1}>
                <Typography color="primary" p={1} px={2} fontSize={20}>
                  Assign Task
                </Typography>
                <Grid container spacing={2} sx={{ px: 2 }}>
                  <Grid item sm={12}>
                    {accordianViewList?.length > 0 && accordianTaskView()}
                  </Grid>
                  {/* <Grid item spacing={1} sm={12}> */}
                  {editableTaskView()}
                  {/* </Grid> */}
                </Grid>
              </Grid>
            )}
          </Grid>
        </Box>
      </Grid>
      <Grid sx={{ marginBottom: '-50px' }} py={1}>
        <Grid container px={2}>
          {accordianViewList?.length > 0 && actionsOnAccordianTaskView()}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AddTaskRightDrawer;
